// extracted by mini-css-extract-plugin
export default {"bubbleOption":"bubbleOption__peTUV9VG","selected":"selected__jY1VgrfT","text":"text__diX8CD_7","optionFullWidth":"optionFullWidth__ceI2FfTS"};